module.exports = __webpack_public_path__ + "static/media/che7.e96590e4.png";